import { cn } from "@/utils"

const Card = ({ children, className }: { children: React.ReactNode, className?: string }) => {
  return (
    <div className={cn("bg-[var(--surface-card)] rounded-xl border border-[var(--border-default)]", className)}>
      {children}
    </div>
  )
}

const CardHeader = ({ children, className }: { children: React.ReactNode, className?: string }) => {
  return (
    <div className={cn("px-6 py-4 border-b border-[var(--border-default)]", className)}>
      {children}
    </div>
  )
}


const CardContent = ({ children, className }: { children: React.ReactNode, className?: string }) => {
  return (
    <div className={cn("px-6 py-4", className)}>
      {children}
    </div>
  )
}

const CardFooter = ({ children, className }: { children: React.ReactNode, className?: string }) => {
  return (
    <div className={cn("px-6 py-4 border-t border-[var(--border-default)]", className)}>
      {children}
    </div>
  )
}

Card.Header = CardHeader
Card.Content = CardContent
Card.Footer = CardFooter

export default Card
